import React from "react";
import { Link, Redirect } from "react-router-dom";
import Logo from "../../assets/images/logo_marketplace.png";
import appConfig from "../../config/appConfig";
import AuthService from "../../services/AuthService";
import UserService from "../../services/UserService";

class Registration extends React.Component {
  state = {
    isLoad: true,
    firstName: "",
    lastName: "",
    email: "",
    codiceFiscale: "",
    address: "",
    password: "",
    isSubmitting: false,
    error: "",
    success: "",
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isLoad: false });
    }, 500);
    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");
  }

  onFieldChange = (field, value) => {
    this.setState({
      [field]: field === "codiceFiscale" ? value.toUpperCase() : value,
      error: "",
      success: "",
    });
  };

  onSubmit = async (event) => {
    event.preventDefault();

    const { firstName, lastName, email, codiceFiscale, address, password } = this.state;
    if (!firstName || !lastName || !email || !codiceFiscale || !address || !password) {
      this.setState({
        error: "Compila Nome, Cognome, Email, Codice fiscale, Indirizzo e Password per registrarti.",
        success: "",
      });
      return;
    }

    this.setState({
      isSubmitting: true,
      error: "",
      success: "",
    });

    try {
      const response = await AuthService.register({
        firstName,
        lastName,
        email,
        codiceFiscale,
        address,
        password,
      });

      this.setState({
        isSubmitting: false,
        success:
          response?.message ||
          "Registrazione completata. Verifica la tua email prima di accedere all'area clienti.",
      });
    } catch (error) {
      this.setState({
        isSubmitting: false,
        error:
          error?.response?.data?.detail ||
          "Registrazione non riuscita. Riprova tra poco.",
      });
    }
  };

  renderField = (label, field, type = "text", placeholder = "") => (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label
        style={{
          marginBottom: 0,
          color: "#16324f",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        }}
      >
        {label}
      </label>
      <input
        type={type}
        className="form-control"
        value={this.state[field]}
        placeholder={placeholder}
        style={{
          minHeight: 54,
          borderRadius: 16,
          border: "1px solid rgba(13, 91, 164, 0.14)",
          background: "linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%)",
          boxShadow: "none",
          color: "#16324f",
        }}
        onChange={(event) => this.onFieldChange(field, event.target.value)}
      />
    </div>
  );

  render() {
    if (appConfig.auth.enableKeycloak && UserService.isLoggedIn()) {
      return <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />;
    }

    const pageStyle = {
      minHeight: "100vh",
      background: "linear-gradient(90deg, #eff7ff 0%, #f5faff 40%, #ffffff 40%, #f8fbff 100%)",
    };
    const authMainStyle = { textAlign: "left" };
    const shellStyle = {
      width: "100%",
      maxWidth: 1240,
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) minmax(420px, 520px)",
      gap: 40,
      alignItems: "center",
      textAlign: "left",
    };
    const heroStyle = {
      background: "transparent",
      color: "#16324f",
      boxShadow: "none",
      border: "0",
      minHeight: 520,
      padding: "32px 16px 32px 8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      textAlign: "left",
      width: "100%",
    };
    const brandStyle = {
      marginBottom: 26,
      width: "100%",
      textAlign: "left",
    };
    const badgeStyle = {
      display: "inline-flex",
      alignSelf: "flex-start",
      marginBottom: 16,
      padding: "8px 14px",
      borderRadius: 999,
      background: "rgba(13, 91, 164, 0.10)",
      color: "#0d5ba4",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
    };
    const titleStyle = {
      marginBottom: 16,
      color: "#16324f",
      fontSize: 48,
      lineHeight: 1.06,
      fontWeight: 700,
      maxWidth: 560,
      textAlign: "left",
    };
    const descriptionStyle = {
      maxWidth: 520,
      marginBottom: 28,
      color: "#4e667d",
      fontSize: 17,
      lineHeight: 1.8,
      textAlign: "left",
    };
    const highlightsWrapStyle = {
      display: "flex",
      flexDirection: "column",
      gap: 14,
      justifyContent: "flex-start",
      width: "100%",
      maxWidth: 520,
    };
    const highlightStyle = {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      color: "#16324f",
      fontWeight: 600,
      lineHeight: 1.6,
      textAlign: "left",
    };
    const panelStyle = {
      padding: 32,
      borderRadius: 28,
      background: "#ffffff",
      boxShadow: "0 24px 54px rgba(17, 77, 130, 0.10)",
      border: "1px solid rgba(13, 91, 164, 0.08)",
    };
    const panelTitleStyle = {
      margin: "10px 0 8px",
      color: "#16324f",
      fontSize: 30,
      lineHeight: 1.15,
      fontWeight: 700,
    };
    const panelDescriptionStyle = {
      margin: 0,
      color: "#6f889f",
      lineHeight: 1.7,
    };
    const formGridStyle = {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 16,
      marginTop: 24,
    };
    const singleFieldStyle = {
      display: "grid",
      gap: 16,
      marginTop: 16,
    };
    const submitButtonStyle = {
      color: "#ffffff",
      width: "100%",
      padding: "15px 32px",
      minHeight: 56,
      border: "0",
      borderRadius: 16,
      background: "linear-gradient(135deg, #0d5ba4 0%, #1fa2ff 100%)",
      boxShadow: "0 18px 34px rgba(13, 91, 164, 0.22)",
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1.1,
      textAlign: "center",
      marginTop: 22,
    };

    return (
      <div className="theme-blue marketplace-login-page" style={pageStyle}>
        <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? "block" : "none" }}>
          <div className="loader">
            <div className="m-t-30">
              <img src={require("../../assets/images/logo_marketplace.png")} width="48" height="48" alt="Marketplace" />
            </div>
            <p>Please wait...</p>
          </div>
        </div>

        <div className="hide-border marketplace-login-shell">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main marketplace-auth-main" style={authMainStyle}>
              <div className="auth-box marketplace-login-box" style={shellStyle}>
                <div className="marketplace-login-card__hero" style={heroStyle}>
                  <div className="marketplace-login-card__brand" style={brandStyle}>
                    <img src={Logo} alt="Marketplace" className="marketplace-login-card__logo" style={{ filter: "none", maxWidth: 460 }} />
                  </div>
                  <span style={badgeStyle}>Area clienti</span>
                  <h1 style={titleStyle}>Crea il tuo account cliente Marketplace</h1>
                  <p style={descriptionStyle}>
                    Registrati prima del checkout oppure direttamente da questa pagina per inviare richieste, ricevere offerte e seguire tutto il percorso nel marketplace.
                  </p>
                  <div className="marketplace-login-card__highlights" style={highlightsWrapStyle}>
                    {[
                      "Codice fiscale obbligatorio",
                      "Verifica email prima dell'accesso",
                      "Storico richieste sempre disponibile",
                    ].map((highlight) => (
                      <span key={highlight} style={highlightStyle}>
                        <i className="fa fa-check-circle" style={{ color: "#1fa2ff" }}></i>
                        {highlight}
                      </span>
                    ))}
                  </div>
                  <div style={{ marginTop: 32, color: "#16324f" }}>
                    Hai gia un account cliente?{" "}
                    <Link to={`${process.env.PUBLIC_URL}/login?role=customer`} style={{ color: "#0d5ba4", fontWeight: 600 }}>
                      Accedi all'area clienti
                    </Link>
                  </div>
                </div>

                <div style={panelStyle}>
                  <span style={badgeStyle}>Nuovo cliente</span>
                  <h2 style={panelTitleStyle}>Dati essenziali del profilo</h2>
                  <p style={panelDescriptionStyle}>
                    Inserisci i dati base per creare l'account Marketplace e confermare poi l'email dal link che riceverai.
                  </p>

                  <form onSubmit={this.onSubmit}>
                    <div style={formGridStyle}>
                      {this.renderField("Nome", "firstName", "text", "Mario")}
                      {this.renderField("Cognome", "lastName", "text", "Rossi")}
                    </div>

                    <div style={singleFieldStyle}>
                      {this.renderField("Email", "email", "email", "cliente@email.it")}
                    </div>

                    <div style={singleFieldStyle}>
                      {this.renderField("Codice fiscale", "codiceFiscale", "text", "RSSMRA80A01H501U")}
                    </div>

                    <div style={singleFieldStyle}>
                      {this.renderField("Indirizzo", "address", "text", "Via Roma 10, Milano")}
                    </div>

                    <div style={singleFieldStyle}>
                      {this.renderField("Password", "password", "password", "Inserisci una password sicura")}
                    </div>

                    {this.state.error ? <div className="alert alert-danger" style={{ marginTop: 18, borderRadius: 14 }}>{this.state.error}</div> : null}
                    {this.state.success ? <div className="alert alert-success" style={{ marginTop: 18, borderRadius: 14 }}>{this.state.success}</div> : null}

                    <button type="submit" className="btn btn-primary btn-lg marketplace-login-primary" style={submitButtonStyle} disabled={this.state.isSubmitting}>
                      {this.state.isSubmitting ? "Registrazione in corso..." : "Crea account cliente"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Registration;

